import {
  faSignature,
  faClipboardQuestion,
  faExternalLink
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo, useContext } from 'react';

import { Color } from '@/constants/color';
import PersonContext from '@/pages/Person/PersonContext';
import { DocumentStatus } from '@/types/requestedFormCompletion';
import Badge from '@/ui/components/Badge';
import ListCard from '@/ui/components/ListCard';
import usFormatDateString from '@/utils/usFormatDateString';

import type { Props } from './types';

const statusColorMap = {
  [DocumentStatus.Incomplete]: Color.RED,
  [DocumentStatus.Open]: Color.YELLOW,
  [DocumentStatus.Finished]: Color.GREEN
};

const RequestedFormCompletionItem = ({ requestedFormCompletion }: Props) => {
  const {
    person: { external_links }
  } = useContext(PersonContext);
  const healthieDomain = external_links.healthie
    ? new URL(external_links.healthie.url).origin
    : undefined;
  const { form_answer_group_healthie_id } = requestedFormCompletion;
  const showHealthieLink = form_answer_group_healthie_id && healthieDomain;
  const isSigned = requestedFormCompletion.status === DocumentStatus.Finished;

  return (
    <ListCard
      {...(showHealthieLink && {
        headingActions: (
          <a
            className="text-gray-500 hover:text-gray-700 flex items-center"
            href={`${healthieDomain}/form_answer_groups/${requestedFormCompletion.form_answer_group_healthie_id}`}
            rel="noreferrer"
            target="_blank"
            title="View in Healthie">
            <FontAwesomeIcon icon={faExternalLink} />
          </a>
        )
      })}
      headingIcon={isSigned ? faSignature : faClipboardQuestion}
      headingIconClassName={isSigned ? 'text-green-700' : 'text-gray-400'}
      debug={requestedFormCompletion}
      subtitle={requestedFormCompletion.description}
      timestamp={{ datetime: requestedFormCompletion.created_at }}
      title={requestedFormCompletion.name}>
      <div className="space-x-2 space-y-1">
        <Badge color={statusColorMap[requestedFormCompletion.status]}>
          {requestedFormCompletion.status}
        </Badge>

        {requestedFormCompletion.signed_at && (
          <Badge color={Color.GRAY}>
            Signed at: {usFormatDateString(requestedFormCompletion.signed_at)}
          </Badge>
        )}

        <Badge color={Color.GRAY}>Requested by: {requestedFormCompletion.requested_by_name}</Badge>
      </div>
    </ListCard>
  );
};
export default memo(RequestedFormCompletionItem);
